'use strict';

import React                from 'react';
import ReactDOM             from 'react-dom';
import {Treebeard}            from 'react-treebeard';
import Avatar               from 'material-ui/Avatar';
import ListItem             from 'material-ui/List/ListItem';
import NotificationsIcon    from 'material-ui/svg-icons/social/notifications';
import PersonAdd    from 'material-ui/svg-icons/social/person-add';
import IconButton           from 'material-ui/IconButton';
import Badge                from 'material-ui/Badge';
import {Link}                 from 'react-router-dom';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../services/fetchTools';
import CustomerDetails from '../../views/partner/crud/customerDetails'
import Modal from 'react-modal';

import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

const customStyles = {
  content : {
    top                   : '1%',
    left                  : '1%',
    right                 : '1%',
    bottom                : '1%',    
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
    zIndex   : '10000'
   }
};



const nodes = [{
    value: 'mars',
    label: 'Mars',
    children: [
        { value: 'phobos', label: 'Phobos' },
        { value: 'deimos', label: 'Deimos' },
    ],
},{
    value: 'earth',
    label: 'Earth',
    children: [
        { value: 'moon', label: 'Moon' },
        { value: 'deimos', label: 'Deimos' },
    ],
}];

class LocationMenu3 extends React.Component {



    constructor(props){
        super(props);

        this.seconds = 0;
        this.state = {temp_value: '',
                      datetime:new Date(),
                      customers: [],
                      check_button_type: '',
                      check_link:'',
                      id: '',
                      checked: [],
                      expanded: [],                      
                      popUpVisible: false,
                      source:'cm'}; //TODO - Fix it.
        this.onToggle = this.onToggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.searchCustomer = this.searchCustomer.bind(this);
        this.showTime = this.showTime.bind(this);
        this.checkTime = this.checkTime.bind(this);
        this.setLinktocheck = this.setLinktocheck.bind(this);
        this.handleClicked = this.handleClicked.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onExpand = this.onExpand.bind(this);
    }


  onCheck = (checked) => {
    this.setState({ checked },() => {this.props.reloadData(checked.join());});
  };

  onExpand = (expanded) => {
    console.log(expanded)
    this.setState({ expanded });
  };

    closeModal() {
      this.setState({popUpVisible: false});

    }
    onToggle(node, toggled){
        if(this.state.cursor){this.state.cursor.active = false;}
        node.active = true;
        if(node.children){ node.toggled = toggled; }
        this.setState({ cursor: node });//TODO - Fix it.
        this.props.reloadData(node.id);
    }
    getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/customer_list/search/?search=${this.state.temp_value}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({ customers: data.results});
        })
       .catch(error => error);
    }

    getDetailsForTimeAndCheckButton(){
      const url = `${getLocationOrigin()}/cm/get_details_for_time_activity/?source=${this.state.source}`;
      const options = {...defaultOptions};
      // console.log('hahahahahhahahahahahhahahahah')
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({ datetime: new Date(data.datetime),
                            check_button_type :data.check_type} ,()=>{this.setLinktocheck()} );
            this.showTime();
            // this.setLinktocheck();
          })
        .catch(error => error);

    }

    setLinktocheck(){
      if(this.state.check_button_type == 'Check-Out'){
        this.setState({check_link:'/crud/checkout'});
      }
      else{
        this.setState({check_link:'/crud/checkin'});
      }
      return this.state.check_link;

    }
  


    showTime(time){
      // console.log("showTime");
      // console.log("this.seconds: " + this.seconds);
      
      this.seconds = this.seconds + 1;
      var t = setTimeout(this.showTime,1000);            
      var time = new Date(this.state.datetime.getTime() + this.seconds*1000);      
      var h = time.getHours();
      var m = time.getMinutes();
      var s = time.getSeconds();
      var a = 'AM';
      if(h >= 12){
        h = h % 12;
        h = this.checkTime(h);
        a = 'PM';
      }
      m = this.checkTime(m);
      s = this.checkTime(s);
      if(document.getElementById('time_display')){
        document.getElementById('time_display').innerHTML = h + ":" + m + ":" + s + " "+ a;  
      }      

    }
    checkTime(i) {
      if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
      return i;
    }    


    componentDidMount() {
      this.getDetailsForTimeAndCheckButton();
      this.setLinktocheck()
      // document.getElementsByClassName('rct-node-parent').style.fontSize = "12px";
    }





    handleChange(event){
      console.log(event.target.value);
      this.setState({temp_value: event.target.value});
    }

    handleClicked(cust_id){
      this.setState({popUpVisible:true,id:cust_id});
    }

    searchCustomer() {
    {this.state.temp_value?this.getSearchList(this.state.temp_value):
      alert('Search cannot be blank')}
  }

    render(){
        console.log("theere props");

        if (this.props.user){
          var tickets = this.props.user.tickets
          console.log('props',this.props)
          localStorage.removeItem('permissions')
          localStorage.removeItem('access')
          console.log('permissions before',localStorage.getItem('permissions'))
          localStorage.setItem('permissions',this.props.user.permissions)
          localStorage.setItem('access',this.props.access)
          console.log('permissions after',localStorage.getItem('permissions'))
          console.log('access',this.props.access)
        }

        console.log(this.state.check_link)
        let avatar;
        if(this.props.user){
          avatar = 
          <div> 
            <div style={{display: 'flex', justifyContent: 'center', paddingTop: '7%', flexDirection: 'column'}}>
              <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', textAlign: 'center'}}>
                <div>
                  <Avatar size={90} src={`${this.props.user.photo}`} />
                </div>
                <div style={{color: '#ffff',paddingTop: '5%'}}>
                  <p style={{fontSize: '15px'}}>{this.props.user.name}</p>
                </div>
              </div>

              <div className="center">
                <div>
                  <label id="time_display"></label>
                </div>
                
                
                  <Link to={this.state.check_link}> 
                    <button className="btn" style={{border: 'none', backgroundColor: '#27C24C', margin: '5px'}}>
                    <i className="fa fa-bell-o" style={{fontSize: 'medium', color: '#000'}}></i>
                      <span style={{fontSize: '100%',  margin: '4px', color: '#000'}}>{this.state.check_button_type}</span>
                    </button>
                  </Link>
              
                
                
              </div>

            <div>
            {
              this.props.access != "Technichal Partner" ?
              <div className="input-group" style={{padding: '1%', marginBottom: '10px'}}>
              <input type="text" name="searchinput" className="form-control" placeholder="Search Customer..." onChange={this.handleChange}/>
              <span className="input-group-btn"><button name="search" id="search-btn" className="btn btn-flat" onClick={this.searchCustomer}><i className="fa fa-search"></i></button></span>
            </div>
            :
            <div>
            </div>
            }
            </div>

            <div style={{marginBottom: '4px'}}>
              {
                this.state.customers ?
                this.state.customers.map((cust, index)=>(
                  <div key={index} style={{padding: '1%',border: '1px solid #9ea5aa',cursor:'pointer'}} onClick={()=>{this.handleClicked(cust.id)}}>
                    <Avatar size={35} src={`${cust.user.photo}`} />
                    <span style={{color: '#FFFFFF', textAlign: 'center', marginLeft: '10px', fontSize: '14px', fontWeight: 'bold'}}>{cust.user.name} - {cust.user.mobile_no}</span>
                  </div>
                  ))
                :
                <div></div>
              }

             { this.state.popUpVisible ?
                <div >
                 <Modal
                    isOpen={this.state.popUpVisible}
                    onRequestClose={this.closeModal}
                    style={customStyles}>
                    <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                    <CustomerDetails match={{"params":{"id":this.state.id}}}/> 
                 </Modal>
                </div>
                :
                ""
              }

            </div>
          </div>

        </div>
        } else {
          avatar = null
        }

        console.log('Going to render CheckboxTree')
        console.log(this.props.data.children)
        const { checked, expanded } = this.state;
         this.props.data.children && this.props.data.children.length > 1 && this.props.data.children.forEach(function(city){
          city.label =  <span style={{fontSize: "16px"}}>{city.label}</span>;
          city.children.forEach(function(hood){
            hood.label =  <span style={{fontSize: "14px"}}>{hood.label}</span>;

            hood.children.forEach(function(center){
                center.label = <span style={{fontSize: "12px"}}>{center.label}</span>
            })


         })
         })


        return (
            <div>
              {avatar}
              <CheckboxTree
                  nodes={this.props.data.children}
                  checked={checked}
                  expanded={expanded}
                  onCheck={this.onCheck}
                  onExpand={this.onExpand}
                  checkModel = {'all'}
              />
            </div>
        );
    }
}

export default LocationMenu3;



// WEBPACK FOOTER //
// ./src/app/components/locationMenu/LocationMenu3.js